<script>
export default {
    name: "BillingCategoryForm",

    props: {
        itemGroup: Object,
        showModal: Boolean,
        billingCategories: Array,
    },

    methods: {

        updateBillingCategory(category) {
            let data = {
                tYPEID: category.paramid,
                bILLINGCATEGORYID: this.itemGroup.code,
                uSERNAME: this.$root.username,
                sTATUS: category.status
            };
            this.$root.loading = true;
            this.$http.post(`MasterData/BillingCategories`, data).then(() => {
                this.$root.loading = false;
            }).catch(() => {
                this.$root.loading = false;
            });
        },
    }

}
</script>
<template>
    <tail-modal :show="showModal" dimension="w-8/12 h-auto">
      <template v-slot:title>
        <h5>Billing Categories</h5>
      </template>
      <template v-slot:modal-body>
            <div class="flex flex-wrap">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Code</th>
                            <th>Category</th>
                            <th>Description</th>
                            <th>Username</th>
                            <th>Applicable</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(billingCategory, idx) in billingCategories" :key="idx">
                            <td>{{ billingCategory.paramid }}</td>
                            <td>{{ billingCategory.parameter }}</td>
                            <td>{{ billingCategory.description }}</td>
                            <td>{{ billingCategory.username }}</td>
                            <td>
                                <label :for="`category_${idx}`" class="label-control text-xs">
                                    <input @change="updateBillingCategory(billingCategory)" 
                                    v-model="billingCategory.status" type="checkbox" :value="true" 
                                    :id="`category_${idx}`"></label>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs mr-4" @click="$emit('closeModal')">Cancel</button>
      </template>
    </tail-modal>
</template>

